import { registerFlow } from '../../../../core/flow-register';
import { makeFlow } from '../index';
import { IRAAccountTypes } from '../../../transfer-flows/loaders';

registerFlow(
  makeFlow('roth-ira', {
    toIRAAccountType: IRAAccountTypes.ROTH,
    fromIRAAccountType: IRAAccountTypes.ROTH
  })
);
